<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import SearchHeader from '../../SearchHeader/index.vue'
import { useSidebarStore } from '@/stores/sidebar'
import IconButton from '@/components/IconButton/index.vue'

defineEmits(['toggleOpen', 'backPage'])
defineOptions({ name: 'DrawerHeader' })

const { state, toggleSidebar, goToView } = useSidebarStore()

const { isSmaller } = useBreakpoints(breakpointsTailwind)
const isMobile = ref(isSmaller('md'))
useResizeObserver(window.document.body, () => {
  isMobile.value = isSmaller('md')
})

const searchHeaderRef = ref<InstanceType<typeof SearchHeader> | null>(null)

useEventListener('keydown', (event) => {
  if ((event.key === 'f' && event.ctrlKey) || (event.key === 'f' && event.metaKey)) {
    if (state.isOpen) {
      searchHeaderRef.value?.focusField()
      event.preventDefault()
    }
  }
})
</script>

<template>
  <div class="flex justify-center items-center z-36 bg-white max-h-[58px] min-h-10 gap-2 w-full h-full">
    <IconButton v-if="state.isOpen && (state.mode === 'edit' || state.mode === 'export')" class="mr-auto ml-1" @click="goToView(isMobile)">
      <div i-material-symbols:arrow-back-ios-rounded />
    </IconButton>
    <SearchHeader v-if="state.mode === 'view' && state.isOpen" ref="searchHeaderRef" />
    <div v-if="state.mode === 'edit' || state.mode === 'export' || state.mode === 'folder' && state.isOpen" id="drawer-header-content" class="w-full h-full max-w-full overflow-hidden flex" />
    <IconButton v-if="!isMobile" class="w-9 h-9" :class="{ 'mr-[14px]': state.isOpen }" title="Toggle Your Library" rotate-180 rounded @click="toggleSidebar()">
      <template v-if="state.isOpen">
        <IconDockLeft class="w-6 h-6 border-box" />
      </template>
      <template v-else>
        <IconDockRight class="w-6 h-6" />
      </template>
    </IconButton>
  </div>
  <div v-if="!state.isOpen" p-2 flex justify-center items-center>
    <div invisible sm:visible text-xs border-1 border-softGray p-1 rounded text-darkGray>
      <span>Alt</span>
      <span>/</span>
    </div>
  </div>
</template>
